import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export interface CityTaxMailbox {
  id?: number;
  name: string;
  databoxId?: string;
  address?: string;
  district?: string;
}

export const getCityTaxMailboxes = async (): Promise<CityTaxMailbox[]> => {
  const res = await axios.get(`${API_BASE}/city-tax-mailboxes`, { withCredentials: true });
  return res.data;
};

export const adminGetCityTaxMailboxes = async (token: string): Promise<CityTaxMailbox[]> => {
  const res = await axios.get(`${API_BASE}/admin/city-tax-mailboxes`, {
    headers: { Authorization: `Bearer ${token}` }, withCredentials: true,
  });
  return res.data;
};

export const adminCreateCityTaxMailbox = async (payload: CityTaxMailbox, token: string): Promise<CityTaxMailbox> => {
  const res = await axios.post(`${API_BASE}/admin/city-tax-mailboxes`, payload, {
    headers: { Authorization: `Bearer ${token}` }, withCredentials: true,
  });
  return res.data;
};

export const adminUpdateCityTaxMailbox = async (id: number, payload: CityTaxMailbox, token: string): Promise<CityTaxMailbox> => {
  const res = await axios.put(`${API_BASE}/admin/city-tax-mailboxes/${id}`, payload, {
    headers: { Authorization: `Bearer ${token}` }, withCredentials: true,
  });
  return res.data;
};

export const adminDeleteCityTaxMailbox = async (id: number, token: string): Promise<void> => {
  await axios.delete(`${API_BASE}/admin/city-tax-mailboxes/${id}`, {
    headers: { Authorization: `Bearer ${token}` }, withCredentials: true,
  });
};
